// ----------------------------------------------------------------------

import LoadingButton from '@mui/lab/LoadingButton';
import { Box, Card, CardContent, Grid, Stack, Typography } from '@mui/material';
import FormProvider, { RHFRadioGroup, RHFTextField } from 'src/components/hook-form';
import RHFMaskField from 'src/components/hook-form/rhf-mask';
import { useMyDataStore } from 'src/store/me/me.store';

type options = {
  label: string;
  value: string;
};

type Props = {
  methods: any;
  onSubmit: VoidFunction;
  STATUS_OPTIONS: options[];
  isEdit: boolean;
  isSubmitting: boolean;
};

export default function ShopkeeperForm({
  methods,
  STATUS_OPTIONS,
  isEdit,
  isSubmitting,
  onSubmit,
}: Props) {

  const permissions = useMyDataStore((state) => state.me?.cnAdminInfo?.permissions?.usersShopkeepers)

  return (
    <FormProvider methods={methods} onSubmit={onSubmit}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Card>
            <CardContent>
              <Stack spacing={2}>
                <RHFTextField name="name" label="Nome" />

                <RHFTextField name="code" label="Código" />

                <RHFMaskField name="cnpj" label="CNPJ" mask="**.***.***/****-99" />
                <Stack>
                  <Typography variant="subtitle2" color="text.secondary">
                    Status:
                  </Typography>
                  <Box width="8px" />
                  <RHFRadioGroup name="status" options={STATUS_OPTIONS} />
                </Stack>
              </Stack>
              <Stack alignItems="flex-end" sx={{ mt: 3 }}>
                <LoadingButton type="submit" variant="contained" loading={isSubmitting} disabled={(isEdit && !permissions?.update) || (!isEdit && !permissions?.create)}>
                  {!isEdit ? 'Cadastrar Lojista' : 'Salvar alterações'}
                </LoadingButton>
              </Stack>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </FormProvider>
  );
}
